import request from '@/utils/request'


export function queryRequest(data) {
  return request({
    url: '/db/acct/query',
    method: 'post',
    data
  })
}

export function hospModelAcctAdd(data) {
  return request({
    url: '/db/acct',
    method: 'put',
    data
  })
}
export function deleteAcct(id){
  return request({
    url: '/db/acct/'+id,
    method: 'delete'
  })
}

export function hospUserInfoQuery(data) {
  return request({
    url: '/db/acct/hosp-user-info',
    method: 'post',
    data
  })
}


